import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal, computed } from '@angular/core';
import { ecorEnv } from 'environments/environment';
import { Observable, shareReplay } from 'rxjs';

export interface AppSettings {
    pegaIntegration: boolean
}
@Injectable({
    providedIn: 'root'
})
export class AppSettingsService {
    private httpClient = inject(HttpClient);
    
    // Signal-based state management
    private _responseCache = signal<Map<string, any>>(new Map());
    private _url = signal<string>(ecorEnv.apiEndpoint + '/secure/settings');
    
    // Computed properties
    responseCache = computed(() => this._responseCache());
    url = computed(() => this._url());
    private appSettings$: Observable<AppSettings> | undefined;

    getAppSettings(): Observable<AppSettings> {
        if (!this.appSettings$) {
            this.appSettings$ = this.httpClient
                .get<AppSettings>(this._url(), { responseType: 'text' as 'json' })
                .pipe(shareReplay(1));
        }
        return this.appSettings$;
    }
}